

import React from 'react';
import { isMobile } from 'react-device-detect';
import { View } from '@coinscrap/webapp-core';

import InputLabel from 'components/InputLabel/InputLabel';
import { OptionButton } from 'components/OptionButton/OptionButton';

export const ProfessionQuestions = ({
	professionQuestions,
	professionResponses,
	setProfessionResponses,
}) => {
	return professionQuestions.map((question) => {
		return (
			(parseInt(question.id) === 1 || professionResponses[question.id - 1] === false) && (
				<View inputFreeRowSt key={question.id}>
					<InputLabel type="custom" label={question.description}>
						<View
							rowSt
							justifyStartSt
							style={{
								gap: isMobile ? '20px' : '12px',
								flexWrap: 'wrap',
							}}
						>
							<OptionButton
								onClick={() =>
									setProfessionResponses((prevState) => {
										return {
											...prevState,
											[question.id]: true,
										};
									})
								}
								selected={professionResponses[question.id] === true}
								text={'Sí'}
								style={{
									width: isMobile ? '100%' : undefined,
									margin: isMobile ? 0 : undefined,
								}}
							/>
							<OptionButton
								onClick={() =>
									setProfessionResponses((prevState) => {
										return {
											...prevState,
											[question.id]: false,
										};
									})
								}
								selected={professionResponses[question.id] === false}
								text={'No'}
								style={{
									width: isMobile ? '100%' : undefined,
									margin: isMobile ? 0 : undefined,
								}}
							/>
						</View>
					</InputLabel>
				</View>
			)
		);
	});
};
